import {type ReactNode} from 'react';
import {Grid} from '@mui/material';

type AdminBookmarksCardGridItemProps = {
  children: ReactNode;
}

const AdminBookmarksCardGridItem = ({ children } : AdminBookmarksCardGridItemProps) => (
  <Grid item xxs={12} sm={6} lg={6} xl={6}>
    {children}
  </Grid>
);

export default AdminBookmarksCardGridItem;